<div *ngIf="user" [formGroup]="form" class="row">
  <div class="col-md-12">
    <div class="card">
      <div class="card-header" style="padding-bottom: 0">
        <h4 class="modal-title">
          {{ 'EditUser' | translate }}
        </h4>
        <hr />
      </div>
      <div class="card-body" style="padding-top: 0">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label [innerHtml]="'Nom' | translate"></label>
              <input formControlName="lastName" type="text" class="form-control" />
            </div>
            <div class="form-group">
              <label [innerHtml]="'Prenom' | translate"></label>
              <input formControlName="firstName" type="text" class="form-control" />
            </div>
            <div class="form-group">
              <label class="star" [innerHtml]="'AdresseMail' | translate"></label>
              <input formControlName="email" type="text" class="form-control" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label [innerHtml]="'role' | translate"></label>
              <select formControlName="profile" class="form-control">
                <option value="">—</option>
                @for (profil of profiles; track profil.id) {
                  <option [value]="profil.code">
                    {{ profil.libelle }}
                  </option>
                }
              </select>
            </div>
            <div class="form-group">
              <label>Langue</label>
              <select formControlName="lang" class="form-control">
                <option value="fr">{{ 'FR' | translate }}</option>
                <option value="en">{{ 'EN' | translate }}</option>
              </select>
            </div>
            <div class="form-group">
              <label>{{ 'API Key' | translate }}</label>
              <input formControlName="apiKey" type="text" class="form-control" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label [innerHtml]="'Active' | translate"></label>
              <app-switch formControlName="active" [showLabels]="false" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label [innerHtml]="'MFA'"></label>
              <input type="text" disabled [value]="user.mfa"/>
            </div>
          </div>
        </div>
        <div>
          <h5>{{ 'Organizations' | translate }}</h5>
          <table class="table table-hover table-fixed">
            <thead>
              <tr>
                <th>{{ 'Nom' | translate }}</th>
                <th>{{ 'role' | translate }}</th>
                <th class="actions"></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let org of user.organizations">
                <td>
                  <a [routerLink]="['/',ADMIN_PREFIX,ORGANIZATIONS_ROUTE,org.organization.code]">{{ org.organization.name }}</a>
                  <app-badge-organization [code]="org.organization.code"></app-badge-organization>
                </td>
                <td>{{ org.role }}</td>
                <td class="actions">
                  <i
                    (click)="adminService.connectAsUser(user, org.organization.code)"
                    style="color: #4099ff; font-size: 20px"
                    class="pointer icofont icofont-eye"
                    title="{{ 'ConnectAsThisUser' | translate }}"
                  ></i
                  >&nbsp;&nbsp;
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="card-footer">
        <button *ngIf="!user.lastLoginDate" (click)="resendRegistrationMail(user)" class="btn btn-sm btn-success mr-2">
          {{ 'ResendRegistrationEmail' | translate }}<i class="icofont icofont-send-mail"></i>
        </button>
        <button
          [disabled]="!form.valid"
          (click)="updateUser()"
          class="btn btn-sm btn-primary mr-2"
          [innerHtml]="'Enregistrer' | translate"
        ></button>
        <button (click)="cancel()" class="btn btn-sm btn-danger" [innerHtml]="'Annuler' | translate"></button>
      </div>
    </div>
  </div>
</div>
